import React, { memo } from "react";
import { Skeleton } from "@/components/ui/skeleton";

export const StockPicksLoadingSkeleton = memo(() => (
  <div className="grid grid-cols-1 gap-3">
    {[...Array(3)].map((_, i) => (
      <div key={i} className="border border-white/10 rounded-lg p-3">
        <div className="flex justify-between items-start">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <Skeleton className="h-5 w-12" />
              <Skeleton className="h-5 w-10 rounded-sm" /> {/* Adjusted shape */}
            </div>
            <Skeleton className="h-4 w-24" />
          </div>
          <div className="text-right">
            <Skeleton className="h-5 w-16 mb-1" />
            <Skeleton className="h-4 w-12" />
          </div>
        </div>
      </div>
    ))}
  </div>
));

StockPicksLoadingSkeleton.displayName = 'StockPicksLoadingSkeleton';

export default StockPicksLoadingSkeleton;
